import request from '@/config/axios'

// 夜审日志 VO
export interface NightAuditVO {
  id?: string | number
  shopId: string | number
  auditDate: string
  auditType: string // DAILY=日审 MONTHLY=月审 YEARLY=年审
  startTime?: string
  endTime?: string
  status: string // PENDING/PROCESSING/SUCCESS/FAILED
  totalOrders: number
  totalRevenue: number
  totalCheckin: number
  totalCheckout: number
  errorMsg?: string
  operator?: string
  remark?: string
  createTime?: Date
}

// 获取夜审日志分页
export const getNightAuditPage = (params: any) => {
  return request.get({ url: '/hotel/night-audit/page', params })
}

// 获取夜审日志详情
export const getNightAudit = (id: string | number) => {
  return request.get({ url: '/hotel/night-audit/get?id=' + id })
}

// 创建夜审日志
export const createNightAudit = (data: NightAuditVO) => {
  return request.post({ url: '/hotel/night-audit/create', data })
}

// 更新夜审日志
export const updateNightAudit = (data: NightAuditVO) => {
  return request.put({ url: '/hotel/night-audit/update', data })
}

// 删除夜审日志
export const deleteNightAudit = (id: string | number) => {
  return request.delete({ url: '/hotel/night-audit/delete?id=' + id })
}

// 执行夜审（no-show + 房态锁定 + 当日统计）
export const executeNightAudit = (shopId: string | number, auditDate: string) => {
  return request.post({ url: `/hotel/night-audit/execute?shopId=${shopId}&auditDate=${auditDate}` })
}

// 批量删除夜审日志
export const deleteNightAuditList = (ids: (string | number)[]) => {
  return request.delete({ url: '/hotel/night-audit/delete-list?ids=' + ids.join(',') })
}
